<template>
  <div class="app__content section">
    <div class="section__wrapper">
      <div class="section__content">
        <h2 class="">User approval</h2>
        <table class="admin__table">
          <tr class="admin__table-row admin__table-row--heading">
            <th class="admin__table-heading admin__table-cell">
              Full name
            </th>
            <th class="admin__table-heading admin__table-cell">
              Username
            </th>
            <th class="admin__table-heading admin__table-cell">
              Admin
            </th>
            <th class="admin__table-heading admin__table-cell">
              Approved
            </th>
          </tr>
          <tr
            v-for="user in users"
            :key="user.id"
            class="admin__table-row"
          >
            <td class="admin__table-cell">
              {{ user.fullname }}
            </td>
            <td class="admin__table-cell">
              {{ user.username }}
            </td>
            <td class="admin__table-cell">
              {{ user.roles.indexOf('ROLE_ADMIN') > -1 }}
            </td>
            <td class="admin__table-cell">
              <ui-toggle 
                @click.native="toggleUserApproval(user.id, !user.approved)"
                :toggle="user.approved"
              />
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import UiToggle from '../components/ui-toggle';
import { GetUsers, UpdateUserApproval } from '../services/api';

export default {
  name: 'user-approval',
  data() {
    return {
      users: false,
      error: false,
    };
  },
  methods: {
    getUsers() {
      GetUsers().then((res) => {
        this.users = res.data;
      });
    },
    toggleUserApproval(id, newApproval) {
      UpdateUserApproval({ id, approved: newApproval }).then((res) => {
        if (res) this.getUsers();
      })
      .catch(() => {
        this.error = true;
      });
    },
  },
  components: {
    UiToggle,
  },
  mounted() {
    this.$nextTick(() => {
      this.getUsers();
    });
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// user-approval.vue?2086aca3